import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";

const Academics = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "Programs Offered", path: "programs-offered" },
    { name: "Syllabus", path: "syllabus" },
    { name: "Ship in Campus & Labs", path: "ship-in-campus" },
    { name: "Academic Calendar", path: "academic-calendar" },
    { name: "Officer-Like Qualities (OLQ)", path: "officer-qualities" },
    { name: "Faculty Information", path: "faculty-info" },
    { name: "Faculty Research", path: "faculty-research" },
    { name: "Achievements", path: "achievements" },
    { name: "Feedback Report", path: "feedback-report" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name || "Academics";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "programs-offered": {
      title: "Programs Offered",
      bgImage: "/assets/images/inner_bnr/Programs_Offered.jpg",
    },

    syllabus: {
      title: "Syllabus",
      bgImage: "/assets/images/inner_bnr/DSC_2165.jpg",
    },
    "ship-in-campus": {
      title: "Ship in Campus & Labs",
      bgImage: "/assets/images/inner_bnr/Ship-in-Campus-2.webp",
    },

    "academic-calendar": {
      title: "Academic Calendar",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },

    "officer-qualities": {
      title: "Officer-Like Qualities (OLQ)",
      bgImage: "/assets/images/inner_bnr/Officer_Like_Qualities.jpg",
    },

    "faculty-info": {
      title: "Faculty Information",
      bgImage: "/assets/images/inner_bnr/Faculty_Information.jpg",
    },

    "faculty-research": {
      title: "Faculty Research",
      bgImage: "/assets/images/inner_bnr/Faculty_Research.jpg",
    },

    achievements: {
      title: "Achievements",
      bgImage: "/assets/images/inner_bnr/Achievements_Student.jpg",
    },

    "feedback-report": {
      title: "Feedback Report",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },

    "btech-marine": {
      title: "B.Tech in Marine Engineering",
      bgImage: "/assets/images/programs-offered/btech-innerbnr.webp",
    },

    "bsc-nautical": {
      title: "B. Sc. Nautical Science",
      bgImage: "/assets/images/programs-offered/B.Sc-3.webp",
    },

    "diploma-nautical": {
      title: "Diploma In Nautical Science",
      bgImage: "/assets/images/programs-offered/diploma-nautical.webp",
    },

    "electro-technical": {
      title: "Electro Technical Officer",
      bgImage: "/assets/images/programs-offered/ETO-1.webp",
    },
  };

  //  Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key),
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "Academics",
        bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Academics;
